import { render, staticRenderFns } from "./ListsGrowth.vue?vue&type=template&id=53244e78&"
import script from "./ListsGrowth.vue?vue&type=script&lang=js&"
export * from "./ListsGrowth.vue?vue&type=script&lang=js&"
import style0 from "./ListsGrowth.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports